const { adminCall } = require("./_utils")

module.exports = {
  invite: data => adminCall("guest.invite", data),
  create: data => adminCall("guest.create", data),
  modify: data => adminCall("guest.modify", data),
  remove: uid => adminCall("guest.remove", {uid})
}
